"use client";

import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Check } from "lucide-react";
import { Button } from "./ui/button";
import { ANNUAL_PRICE } from "@/lib/pricing";

interface PricingCardProps {
  onGetStarted?: () => void;
}

export const PricingCard = ({ onGetStarted }: PricingCardProps) => {
  return (
    <Card className="flex flex-col">
      <CardHeader className="pb-4">
        <CardTitle className="text-3xl font-bold text-center">
          Full Access
        </CardTitle>
        <CardDescription className="text-center text-lg">
          All the tools you need to manage your season.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex-1">
        <div className="text-center mb-6">
          <span className="text-5xl font-extrabold">${ANNUAL_PRICE}</span>
          <span className="text-lg text-muted-foreground">/year</span>
        </div>
        <ul className="space-y-3">
          <li className="flex items-center gap-2">
            <Check className="text-green-500 size-5" />
            <span>Unlimited Game Logging</span>
          </li>
          <li className="flex items-center gap-2">
            <Check className="text-green-500 size-5" />
            <span>Payment & Mileage Tracking</span>
          </li>
          <li className="flex items-center gap-2">
            <Check className="text-green-500 size-5" />
            <span>Advanced Stats Dashboard</span>
          </li>
          <li className="flex items-center gap-2">
            <Check className="text-green-500 size-5" />
            <span>Voice-Powered Game Entry</span>
          </li>
          <li className="flex items-center gap-2">
            <Check className="text-green-500 size-5" />
            <span>Data Import & Export</span>
          </li>
        </ul>
      </CardContent>
      <CardFooter className="flex flex-col gap-2">
        <Button className="w-full" size="lg" onClick={onGetStarted}>
          Get Started
        </Button>
        <p className="text-xs text-center text-muted-foreground">
          Have a promo code? You can apply it at checkout.
        </p>
      </CardFooter>
    </Card>
  );
};
